import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { LookUpService } from 'src/app/core/services/basicServices/look-up.service';
import { ShipmentsService } from 'src/app/core/services/basicServices/shipments.service';
import { Messages, Patterns } from 'src/app/helpers';

@Component({
  selector: 'app-add-edit-shipment',
  templateUrl: './add-edit-shipment.component.html',
  styleUrls: ['./add-edit-shipment.component.scss']
})
export class AddEditShipmentComponent implements OnInit {

  form: FormGroup;
  dimUnits = [{ id: 'IN', name: 'Inches' }];
  weightUnits = [{ id: 'OZ', name: 'Ounces' }];
  countryList = [];
  statesList = [];
  statesListTo = [];
  cityList = [];
  cityListTo = [];
  boxSizes = [];
  selectedBoxSize: any = null;
  rateList = [];
  selectedRate = null;
  shipmentDate = null;
  soNo = null;
  validationMessages = Messages.validation_messages;
  constructor(
    public formBuilder: FormBuilder, public router: Router,
    private shipmentService: ShipmentsService,
    private lookupService: LookUpService,
    public Alerts: MatSnackBar) { }

  ngOnInit() {
    this.validateForm();
    this.getCoutries();
    this.getBoxSizes();
  }

  selectBoxSize(items) {
    this.selectedBoxSize = items;
  }
  check() {
    let a = this.form.value;
    a.rates = this.selectedRate;
    a.dateOfShipment = this.shipmentDate;
    a.salesOrderNumber = this.soNo;
    this.shipmentService.createShipment(a).subscribe(res => {
      if (res.shipmentId) {
        this.router.navigate(["main/viewShipment/"], { queryParams: { id: res.shipmentId } });
        this.Alerts.open('Shipment created successfully', 'OK');
      }
    })

  }
  getBoxSizes() {
    this.shipmentService.getBoxSizes().subscribe(res => {
      if (res.length > 0) {
        this.boxSizes = res;
      }
      else {
        this.boxSizes = [];
      }
    })
  }
  getCoutries() {
    this.lookupService.getAllCountries().subscribe(res => {
      if (res.length > 0) {
        this.countryList = res;
      }
      else {
        this.countryList = [];
      }
    })
  }

  getStates(id, val) {
    this.lookupService.getAllStates(id).subscribe(res => {
      if (res.length > 0) {
        if (val == 0) {
          this.statesList = res;
        }
        else {
          this.statesListTo = res;
          const pos = this.form.get('toAddress.postalCode');
          if(this.form.get('fromAddress.countryCode').value != this.form.get('toAddress.countryCode').value){
            if (pos) {
              pos.clearValidators(); // Remove all validators
              pos.setValidators(Validators.required)// Recalculate validation status
              pos.updateValueAndValidity(); 
              this.createFormArray();
            }
          }
          else{
            this.items.clear();
            pos.setValidators(Validators.compose([Validators.required, Validators.pattern(Patterns.POusa)]))
            pos.updateValueAndValidity(); 
          }
        }
      }
      else {
        if (val == 0) {
          this.statesList = [];
        }
        else {
          this.statesListTo = [];
        }
      }
    })
  }
  // getCities(id,val) {
  //   this.lookupService.getAllCities(id).subscribe(res=>{
  //     if(res.length>0){
  //       if(val==0){
  //         this.cityList=res;
  //       }
  //       else{
  //         this.cityListTo=res;
  //       }
  //     }
  //     else{
  //       if(val==0){
  //         this.cityList=[];
  //       }
  //       else{
  //         this.cityListTo=[];
  //       }
  //     }
  //   })
  // }

  onChange(event, val) {
    if (event) {
      this.getStates(event.code, val);
    }
  }

  // onStateChange(event,val){
  //   if(event){
  //     this.getCities(event.code,val);
  //   }
  // }

  validateForm() {
    this.form = this.formBuilder.group({
      dateOfShipment: [''],
      salesOrderNumber:[''],
      parcelType: [''],
      fromAddress: this.formBuilder.group({
        addressLine1: ['', Validators.required],
        addressLine2: [''],
        addressLine3: [''],
        cityTown: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.nameRegex)])],
        countryCode: [null, Validators.required],
        name: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.nameRegex)])],
        company: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.nameRegex)])],
        phone: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.Phoneusa)])],
        postalCode: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.POusa)])],
        stateProvince: [null, Validators.required],
        email: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.emailRegex)])],
        residential: [false]
      }),
      toAddress: this.formBuilder.group({
        addressLine1: ['', Validators.required],
        addressLine2: [''],
        addressLine3: [''],
        cityTown: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.nameRegex)])],
        countryCode: [null, Validators.required],
        name: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.nameRegex)])],
        company: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.nameRegex)])],
        phone: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.Phoneusa)])],
        postalCode: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.POusa)])],
        stateProvince: [null, Validators.required],
        email: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.emailRegex)])],
        residential: [false]
      }),
      parcel: this.formBuilder.group({
        height: [''],
        length: [''],
        width: [''],
        dimUnit: ['IN'],
        weightUnit: ['OZ'],
        weight: ['', Validators.compose([Validators.required, Validators.pattern(Patterns.Num)])]
      }),
      itemsInfo: this.formBuilder.array([])
    });
  }

  createItem(): FormGroup {
    return this.formBuilder.group({
      description: ['', Validators.compose([Validators.required])],
      quantity: ['', Validators.compose([Validators.required])],
      unitPrice: ['', Validators.compose([Validators.required])],
      weightUnit: ['OZ'],
      weight: ['', Validators.compose([Validators.required])]
    });
  }

  createFormArray(): void {
    this.items.push(this.createItem());
  }
  formArray:any=[];
  get items(): FormArray {
    this.formArray = this.form.get('itemsInfo') as FormArray;
    if (  this.formArray) {
      return   this.formArray;
    }
  }

  addItem(): void {
    this.items.push(this.createItem());
  }

  removeItem(index: number): void {
    if (this.items.length > 1) {
      this.items.removeAt(index);
    } else {
      this.Alerts.open('Cannot remove the only item', 'OK');
    }
  }

  fillStoreAddress() {
    this.shipmentService.getStoreAddress().subscribe(res => {
      if (res) {
        this.form.get('fromAddress').patchValue(res);
        let a = { code: null };
        a.code = res.countryCode;
        this.onChange(a, 0);
      }
    })
  }

  save() {
    if (this.selectedBoxSize) {
      this.form.get('parcel.length').setValue(this.selectedBoxSize.length);
      this.form.get('parcel.height').setValue(this.selectedBoxSize.height);
      this.form.get('parcel.width').setValue(this.selectedBoxSize.width);
      this.form.get('parcelType').setValue(this.selectedBoxSize.parcelType);
      this.shipmentService.getRates(this.form.value).subscribe(res => {
        if (res.rates?.length > 0) {
          this.rateList = res.rates;
        }
        else {
          this.rateList = [];
        }
      })
    }
    else {
      this.Alerts.open('PLease select box size', 'OK');
    }
  }

}
